import React from "react";
import { DivFale } from "./style";
import Logo from '../img/img_logoEPC_medio.png'
import email from '../img/Email.png'
import whatsapp from '../img/WhatsApp.png'
import instagram from '../img/Instagram.png'

export const FaleConosco = () => {

    return (

        <DivFale id="fale-conosco">

            <div className="conteudo">

                <div className="coluna-esquerda">

                    <h1>FALE CONOSCO</h1>

                    <div className="contato-item">
                        <svg className="icone-pin" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" fill="#E53935" />
                        </svg>
                        <div>
                            <strong>Endereço:</strong>
                            <p>Rua Diamantina n° 576, Vila Maria - CEP: 02117-011<br />
                                São Paulo - SP, Brasil</p>
                        </div>
                    </div>

                    <a className="contato-item" href="mailto:etiqueta@etiquetapontocom.net">
                        <img src={email} alt="email" />
                        <div>
                            <strong>E-mail:</strong>
                            <p>etiqueta@etiquetapontocom.net</p>
                        </div>
                    </a>

                    <a className="contato-item" href="http://api.whatsapp.com/send?1=pt_BR&amp;phone=5511981743283" target="_blank" rel="noreferrer">
                        <img src={whatsapp} alt="whatsapp" />
                        <div>
                            <strong>Whatsapp:</strong>
                            <p>(11) 9.8174-3283</p>
                        </div>
                    </a>

                    <a className="contato-item" href="https://www.instagram.com/etiquetapontocom" target="_blank" rel="noreferrer">
                        <img src={instagram} alt="instagram" />
                        <div>
                            <strong>Instagram:</strong>
                            <p>@etiquetapontocom</p>
                        </div>
                    </a>

                </div>

                <div className="coluna-direita">
                    <img className="logo" src={Logo} alt="imagem da logo etiquetapontocom" />

                    <div className="mapa">
                        <iframe
                            title="Mapa da localização da empresa"
                            src="https://www.google.com/maps?q=Rua+Diamantina,+576,+Vila+Maria,+São+Paulo,+SP,+Brasil&output=embed"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            loading="lazy"
                            allowFullScreen
                        />
                    </div>
                </div>

                <div className="linha-final">
                    <span className="quadrado"></span>
                </div>

                <div className="montanhas">
                    <span className="tri amarelo"></span>
                    <span className="tri vermelho"></span>
                    <span className="tri laranja"></span>
                </div>

            </div>

        </DivFale>
    )
}
